import React, { useEffect, useRef } from 'react';
import './testimonials.scss';
import { Container } from 'react-bootstrap';
import 'swiper/css';
import 'swiper/css/navigation';

// Elfsight's own "data-elfsight-app-lazy" attribute only defers rendering
// *inside* their platform - it still downloads platform.js (500+ KB)
// the moment this component mounts, regardless of scroll position. That
// script was showing up as one of the heaviest resources on the page even
// though testimonials sit well below the fold. Gate the script injection
// itself behind an IntersectionObserver so nothing downloads until the
// section is actually about to enter the viewport.
export default function TestimonialsSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return undefined;

    const loadWidget = () => {
      if (document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    };

    if (!('IntersectionObserver' in window)) {
      // No IO support - fall back to loading immediately.
      loadWidget();
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          loadWidget();
          observer.disconnect();
        }
      },
      { rootMargin: '300px 0px' },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="testimonials-section" ref={sectionRef}>
      <div className="overlay">
        <Container>
          <h2 className="section-title text-center">Client Testimonials</h2>
          <div className="section-divider mx-auto"></div>
          <div
            className="elfsight-app-9fc50976-24f2-4037-87a9-7ac2a314c0df"
            data-elfsight-app-lazy
          ></div>
        </Container>
      </div>
    </section>
  );
}
